import { reactive } from 'vue'

export const reloadSafety = reactive({ preparing: false, blockers: 0 })
const hooks = new Set<() => Promise<void>>()
interface Save {
  action: () => Promise<void>
  promise: Promise<void>
  failed: boolean
}
const saves = new Map<string, Save>()

export function blockReload(): () => void {
  reloadSafety.blockers += 1
  let released = false
  return () => {
    if (released) return
    released = true
    reloadSafety.blockers -= 1
  }
}

export function registerBeforeReload(save: () => Promise<void>): () => void {
  hooks.add(save)
  return () => { hooks.delete(save) }
}

// Serialize writes to each resource and retain failed writes for an explicit retry.
export function saveBeforeReload(key: string, action: () => Promise<void>): Promise<void> {
  const previous = saves.get(key)
  const entry: Save = { action, promise: Promise.resolve(), failed: false }
  entry.promise = (previous?.promise.catch(() => undefined) ?? Promise.resolve()).then(action)
  saves.set(key, entry)
  void entry.promise.then(() => {
    if (saves.get(key) === entry) saves.delete(key)
  }, () => { entry.failed = true })
  return entry.promise
}

export async function flushReloadSaves(): Promise<void> {
  for (const hook of [...hooks]) await hook()
  while (saves.size) {
    await Promise.all([...saves].map(([key, save]) => save.failed
      ? saveBeforeReload(key, save.action)
      : save.promise))
  }
}
